<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  stars: number
  percentage: number
  count?: number
}>()
const roundedPercentage = computed(() => {
  const value = Number(props.percentage)
  return isNaN(value) ? 0 : Math.max(0, Math.min(100, Math.round(value)))
})
const barStyle = computed(() => ({
  width: `${roundedPercentage.value}%`
}))
</script>

<template>
  <ClientOnly>
    <figure class="flex items-center gap-4">
      <figcaption class="w-24 flex items-center gap-1">
        <span class="text-sm text-gray-600">{{ stars }} stars</span>
      </figcaption>
      <div
        class="flex-grow bg-[#00372E] rounded-full h-2.5"
        role="presentation"
        aria-hidden="true"
      >
        <div
          class="bg-[#04F5B9] h-2.5 rounded-full transition-all duration-300"
          :style="barStyle"
          role="meter"
          :aria-valuenow="roundedPercentage"
          aria-valuemin="0"
          aria-valuemax="100"
          :aria-label="`${stars} stars: ${roundedPercentage}% of reviews`"
        />
      </div>
      <output class="w-24 text-sm text-gray-700 text-right">
        {{ roundedPercentage }}%<span
          v-if="count !== undefined"
          class="text-xs text-gray-700"
        > ({{ count }})</span>
      </output>
    </figure>
  </ClientOnly>
</template>
